"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InfoModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("./index.styled"));

var _OverlayComponent = require("../OverlayComponent");

var _Button = require("../Button");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var InfoModal = function InfoModal(_ref) {
  var _ref$background = _ref.background,
      background = _ref$background === void 0 ? '#FFF' : _ref$background,
      onClose = _ref.onClose,
      children = _ref.children,
      _ref$hideClose = _ref.hideClose,
      hideClose = _ref$hideClose === void 0 ? false : _ref$hideClose,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title;

  var handleCloseButton = function handleCloseButton(e) {
    if (onClose) onClose();
  };

  return /*#__PURE__*/_react.default.createElement(_OverlayComponent.OverlayComponent, {
    background: background,
    fit: "child",
    onClose: onClose,
    hideClose: hideClose
  }, title && /*#__PURE__*/_react.default.createElement(_index.default.Title, null, title), /*#__PURE__*/_react.default.createElement(_index.default.InfoModal, null, children, !hideClose && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: '15px'
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    "aria-label": "Close Overlay",
    onClick: handleCloseButton
  }, "CLOSE"))));
};

exports.InfoModal = InfoModal;
InfoModal.propTypes = {
  /** Component's ID */
  id: _propTypes.default.string,

  /** Adds spacing at the top of overlay */
  pageSpacing: _propTypes.default.bool,

  /** Controls if overlay will take over entire window or be a set width/height, override fit with 'lightbox' */
  lightbox: _propTypes.default.bool,

  /** Controls sizing of lightbox
   * child - Conform to size of children
   * cover - Takes over page
   * lightbox - Has a set width and height
   */
  fit: _propTypes.default.oneOf(['child', 'cover', 'lightbox']),

  /** Theme of close button */
  buttonTheme: _propTypes.default.oneOf(['default']),

  /** Close handler */
  onClose: _propTypes.default.func,

  /** Overlay content */
  children: _propTypes.default.node,

  /** Setting nested will keep the overlay from enabling/disabling scroll locks */
  nested: _propTypes.default.bool,

  /** Hides close button */
  hideClose: _propTypes.default.bool
};